import React, { useMemo, useState } from "react";
import {
  formatCoin,
  getGameMinimumPlayers,
  getGameNumberOfWinners,
  getGameWheelEntries,
  getGameWinnerEntries,
  getGameWinnerName,
  canLeaveGame,
  isUserCreator,
  getInitials,
} from "../../utils/bondWheelHelpers";

const BondWheelDashboard = ({
  myGames = [],
  selectedGameId,
  onSelectGame,
  selectedGame,
  userId,
  constants,
  onLeave,
  leavingGameId,
}) => {
  const [tab, setTab] = useState("myGames");

  const entries = useMemo(() => getGameWheelEntries(selectedGame), [selectedGame]);

  return (
    <div className="bw-dashboard">
      <div className="bw-dashboard-tabs">
        <button
          type="button"
          className={tab === "myGames" ? "active" : ""}
          onClick={() => setTab("myGames")}
        >
          My Games <span>{myGames.length}</span>
        </button>
        <button
          type="button"
          className={tab === "players" ? "active" : ""}
          onClick={() => setTab("players")}
        >
          Players <span>{entries.length}</span>
        </button>
      </div>

      <div className="bw-dashboard-body">
        {tab === "myGames" ? (
          myGames.length === 0 ? (
            <p className="bw-dashboard-empty">No wheels yet. Create or join one above.</p>
          ) : (
            myGames.map((game) => {
              const active = String(game._id) === String(selectedGameId);
              const winnerEntries = getGameWinnerEntries(game);
              const winner = getGameWinnerName(game);
              const minimumPlayers = getGameMinimumPlayers(game, constants);
              const numberOfWinners = getGameNumberOfWinners(game, constants);
              const playerCount = getGameWheelEntries(game).length;
              const canLeave = canLeaveGame(game, userId, Date.now(), constants);
              const leaving = String(leavingGameId) === String(game._id);
              return (
                <div key={String(game._id)} className={`bw-dash-row ${active ? "active" : ""}`}>
                  <button type="button" className="bw-dash-row-main" onClick={() => onSelectGame?.(game)}>
                    <span className="bw-dash-row-title">
                      {game.status === "Settled" && winnerEntries.length > 0
                        ? `${winnerEntries.length} winner${winnerEntries.length === 1 ? "" : "s"}`
                        : game.status}
                    </span>
                    <span className="bw-dash-row-sub">
                      Pot {formatCoin(game.totalPotAtSettle || game.totalPot)} · {playerCount} joined · min{" "}
                      {minimumPlayers} · {numberOfWinners} win{numberOfWinners === 1 ? "" : "s"}
                      {winner ? ` · ${winner}` : ""}
                    </span>
                  </button>
                  {canLeave ? (
                    <button
                      type="button"
                      className="bw-dash-leave"
                      disabled={leaving}
                      onClick={() => onLeave?.(game)}
                    >
                      {leaving ? "…" : "Leave"}
                    </button>
                  ) : null}
                </div>
              );
            })
          )
        ) : entries.length === 0 ? (
          <p className="bw-dashboard-empty">No players on this wheel yet.</p>
        ) : (
          entries.map((entry, idx) => {
            const name = entry.user?.name || "Player";
            const isYou = String(entry.user?._id || entry.user) === String(userId);
            const isWinner = entry.status === "Won";
            return (
              <div key={String(entry._id || idx)} className={`bw-player-row ${isWinner ? "bw-player-row-win" : ""}`}>
                <span className="bw-player-avatar">{getInitials(name)}</span>
                <div className="bw-player-meta">
                  <span className="bw-player-name">
                    {name}
                    {isYou ? " (you)" : ""}
                    {entry.isCreator || isUserCreator(selectedGame, entry.user?._id) ? " · host" : ""}
                    {isWinner ? " · winner" : ""}
                  </span>
                  <span className="bw-player-status">
                    {entry.status}
                    {isWinner && entry.netPayout ? ` · +${formatCoin(entry.netPayout)}` : ""}
                  </span>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default BondWheelDashboard;
